import React from 'react';

const Dropdown = ({
  options,
  onSelect,
  placeholder,
  selectedValue,
  selectedItems = [],
  multiSelect = false,
  maxSelect = 2,
  isOpen,
  onToggle
}) => {
  const SELECTED = selectedItems.length > 0 
    ? selectedItems.map(option => typeof option === 'object' ? option.title : option).join(', ') 
    : selectedValue && selectedValue !== "" ? selectedValue : placeholder;

  const handleSelect = (option) => {
    let updatedSelectedItems;

    if (multiSelect) {
      const isAlreadySelected = selectedItems.some(item => {
        const VALUE_TO_COMPARE = typeof item === 'object' ? item.value : item;
        return VALUE_TO_COMPARE === (typeof option === 'object' ? option.value : option);
      });

      if (isAlreadySelected) {
        updatedSelectedItems = selectedItems.filter(item => {
          const VALUE_TO_COMPARE = typeof item === 'object' ? item.value : item;
          return VALUE_TO_COMPARE !== (typeof option === 'object' ? option.value : option);
        });
      } else if (selectedItems.length < maxSelect) {
        updatedSelectedItems = [...selectedItems, option];
      } else {
        alert('You can select a maximum of 2 items');
        return;
      }

      const selectedTitles = updatedSelectedItems.map(item => typeof item === 'object' ? item.title : item).join(', ');
      onSelect && onSelect(updatedSelectedItems);
    } else {
      const selectedTitle = typeof option === 'object' ? option.title : option;
      onSelect && onSelect(option);
    }
  };

  return (
    <div className="dropdown">
      <button
        className="btn btn-secondary dropdown-toggle"
        type="button"
        id="dropdownMenuButton"
        aria-expanded={isOpen}
        onClick={onToggle}
      >
        {SELECTED}
      </button>
      <ul
        className={`dropdown-menu ${isOpen ? 'show' : ''}`}
        aria-labelledby="dropdownMenuButton"
      >
        {options.map((option, index) => (
          <li key={typeof option === 'object' ? option.value : index}>
            <button
              className="dropdown-item"
              type="button"
              onClick={() => handleSelect(option)}
            >
              {typeof option === 'object' ? option.title : option}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Dropdown;
